module.exports = "<p \r\n[ngStyle]=\"{backgroundColor: getColor()}\"\r\n[ngClass]=\"{online : serverStatus === 'online'}\">\r\nThe server with id {{ serverId }} is {{ serverStatus }}\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/server-console-1/server/server.component.html
// module id = ./src/app/components/server-console-1/server/server.component.html
// module chunks = main